// extracted by mini-css-extract-plugin
module.exports = {"formContent":"mainPage_formContent_iedMH"};